export function calcularValorParcela(valorOriginal, parcela) {
    const valor = Number(valorOriginal || 0);
    const qtd = Number(parcela || 1);
    if (!qtd) return 0;
    return Number((valor / qtd).toFixed(2));
}

export function calcularValorAberto({ valorOriginal, descontoValor, acrescimoValor, parcela }) {
    const valor = Number(valorOriginal || 0);
    const desconto = Number(descontoValor || 0);
    const acrescimo = Number(acrescimoValor || 0);
    const qtd = Number(parcela || 1);
    if (!qtd) return 0;

    return Number(((valor - desconto + acrescimo) / qtd).toFixed(2));
}

export function aplicarDescontoPercentual({ valor, acrescimoValor, descontoPercentual }) {
    const val = Number(valor || 0);
    const acrescimo = Number(acrescimoValor || 0);
    const perc = Number(descontoPercentual || 0);

    const descontoValor = perc > 0 ? Number((((val + acrescimo) * perc) / 100).toFixed(2)) : 0;
    const valorBaixa = Number((val - descontoValor + acrescimo).toFixed(2));

    return {
        descontoValor,
        valorBaixa,
    };
}

export function aplicarDescontoValor({ valor, acrescimoValor, descontoValor }) {
    const val = Number(valor || 0);
    const acrescimo = Number(acrescimoValor || 0);
    const desconto = Number(descontoValor || 0);

    const descontoPercentual = val + acrescimo > 0 ? Number(((desconto / (val + acrescimo)) * 100).toFixed(2)) : 0;

    const valorBaixa = Number((val - desconto + acrescimo).toFixed(2));

    return {
        descontoPercentual,
        valorBaixa,
    };
}

export function aplicarAcrescimoPercentual({ valor, descontoValor, acrescimoPercentual }) {
    const val = Number(valor || 0);
    const desconto = Number(descontoValor || 0);
    const perc = Number(acrescimoPercentual || 0);

    const acrescimoValor = perc > 0 ? Number((((val - desconto) * perc) / 100).toFixed(2)) : 0;
    const valorBaixa = Number((val + acrescimoValor - desconto).toFixed(2));

    return {
        acrescimoValor,
        valorBaixa,
    };
}

export function aplicarAcrescimoValor({ valor, descontoValor, acrescimoValor }) {
    const val = Number(valor || 0);
    const desconto = Number(descontoValor || 0);
    const acrescimo = Number(acrescimoValor || 0);

    const acrescimoPercentual = val - desconto > 0 ? Number(((acrescimo / (val - desconto)) * 100).toFixed(2)) : 0;

    const valorBaixa = Number((val + acrescimo - desconto).toFixed(2));

    return {
        acrescimoPercentual,
        valorBaixa,
    };
}
